import React from 'react';
import ReactDOM from 'react-dom';

import './css/styles.css';

import Content from './Content';

ReactDOM.render(<Content />, document.getElementById('content'));
